import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * @directive directiveOnlyNumbers
 * @selector '[directiveOnlyNumbers]'
 *
 * @description
 * Directiva de atributo que se aplica a elementos de formulario `<input>` para
 * permitir solo la entrada de caracteres numéricos. Utiliza una expresión
 * regular para validar la entrada y, si se detectan caracteres no numéricos,
 * los elimina del valor del control del formulario asociado.
 *
 * ### Funcionalidades:
 * - **Restricción Numérica:** Asegura que el valor del input contenga únicamente
 * dígitos del 0 al 9. Cualquier otro carácter ingresado será automáticamente
 * removido.
 * - **Configuración del Teclado Numérico:** Al enfocar el elemento input, esta
 * directiva establece el atributo `inputmode` en `'numeric'`. Esto proporciona
 * una sugerencia al navegador (y al sistema operativo) para que muestre un
 * teclado optimizado para la entrada de números en dispositivos móviles.
 *
 * ### Eventos del Host Escuchados (`@HostListener()`):
 * - `input`: Escucha el evento `input` del elemento. Cuando el valor del input
 * cambia, la directiva verifica si contiene caracteres no numéricos. Si los
 * encuentra, utiliza el `NgControl` para actualizar el valor del control de
 * formulario, eliminando estos caracteres.
 * - `focus`: Escucha el evento `focus` del elemento. Cuando el input recibe el
 * foco, la directiva establece el atributo `inputmode` del elemento a `'numeric'`.
 */
@Directive({
  selector: '[directiveOnlyNumbers]'
})
export class OnlyNumbersDirective implements OnInit {

  private regex: RegExp = new RegExp(/^[0-9]*$/);

  constructor(private ngControl: NgControl, private el: ElementRef) {}

  ngOnInit(): void {
    this.el.nativeElement.setAttribute('inputmode', 'numeric');
  }

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if (!this.regex.test(value)) {
      this.ngControl.control?.setValue(value.replace(/[^0-9]/g, ''));
    }
  }
}